import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";

/**
 * Sorts rate plans by priority (ascending: lower priority value = higher in list).
 * Rate plans without a priority (undefined/null) are placed at the end.
 */
export const sortRatePlansByPriority = (ratePlans: RatePlanMerged[]): RatePlanMerged[] => {
  return [...ratePlans].sort((a, b) => {
    const aPriority = a.priority ?? Number.MAX_SAFE_INTEGER;
    const bPriority = b.priority ?? Number.MAX_SAFE_INTEGER;
    return aPriority - bPriority;
  });
};
